import { TextField, Typography } from "@mui/material";
import pageTextConfig from '../../../../assets/configs/Add New Gig Page/PaymentSetupPage/textConfig';

const UPIFormControl = ({paymentFormData, updateFormData}: any) => {
    return (
      <>
        <Typography sx={{ marginBottom: '15px' }}
          variant='body1'>
          {pageTextConfig.enterUPIprompt}
        </Typography>
  
        <TextField
          className="textFields"
          required
          id="outlined-number"
          type={'text'}
          label="Enter UPI ID"
          InputProps={{ style: { fontFamily: "Arial" } }}
          sx={{ width: '70%', marginBottom: '15px' }}
          name='upiId'
          value={paymentFormData.upiId}
          onChange={(e) => updateFormData(e.target.name, e.target.value)}
        />
      </>
    )
  }

  export default UPIFormControl